import type { MapHandle } from '@/components/game/MapView';

/**
 * Phase 7.4.5 — global MapHandle registry. Game.tsx registers its mapRef on
 * mount; consumers (MissionsTab, MissionDetail, …) call `getMapHandle()` to
 * smoothly flyTo a position without prop-drilling.
 */

let current: MapHandle | null = null;

export function registerMapHandle(handle: MapHandle | null): void {
  current = handle;
}

export function getMapHandle(): MapHandle | null {
  return current;
}
